export default __webpack_public_path__ + "static/media/img_papaground01.540ed67e.jpg";